<!-- =========================================================================================
  File Name: FormWizardValidation.vue
  Description: Form wizard with validation
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div>
    <div class="vx-row" v-if="stages">
       <div class="vx-col w-full sm:w-1/3 md:w-1/3 lg:w-1/3 xl:w-1/3 mb-base">
        <statistics-card-line
          hideChart
          class="mb-base"
          icon="SearchIcon"
          icon-right
          :statistic="stages.conference"
          statisticTitle="Conferência"
          :color="color"
        />
      </div>

      <div class="vx-col w-full sm:w-1/3 md:w-1/3 lg:w-1/3 xl:w-1/3 mb-base">
        <statistics-card-line
          hideChart
          class="mb-base"
          icon="PackageIcon"
          icon-right
          :statistic="stages.inRevision"
          statisticTitle="Em revisão"
          :color="color"
        />
      </div>
     <div class="vx-col w-full sm:w-1/3 md:w-1/3 lg:w-1/3 xl:w-1/3 mb-base">
        <statistics-card-line
          hideChart
          class="mb-base"
          icon="DollarSignIcon"
          icon-right
          :statistic="stages.revenues"
          statisticTitle="Faturamento"
          :color="color"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { numberJS } from "@/helpers";
import StatisticsCardLine from "@/components/statistics-cards/StatisticsCardLine.vue";
export default {
  components: {
    StatisticsCardLine,
  },
  data() {
    return {
      totalOrder: 0,
      stages: null,
      color: null,
    };
  },
  methods: {
    showPercentageStage(orders, color) {
      this.color = color;
      let stages = {};
      let conference = 0;
      let inRevision = 0;
      let revenues = 0;

      for (let order of orders) {
        if (order.stage == "Conferência") {
          conference++;
        }
        if (order.stage == "Em revisão") {
          inRevision++;
        }
        if (order.stage == "Faturamento") {
          revenues++;
        }
      }

      let totalStages = conference + inRevision + revenues;
      let percConference = (conference * 100) / totalStages;
      let percInRevision= (inRevision * 100) / totalStages;
      let percRevenues = (revenues * 100) / totalStages;

      stages.conference = numberJS().formatPercent(percConference) + "%";
      stages.inRevision = numberJS().formatPercent(percInRevision) + "%";
      stages.revenues = numberJS().formatPercent(percRevenues) + "%";
      this.stages = stages;
    },
  },
  created() {
    
  },
  mounted() {},
};
</script>
